import {FC} from "react";
import styled from "styled-components";
import {LinearProgress, linearProgressClasses} from "@mui/material";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	font-family: "Khand", sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 160%;
	gap: 3px;
`;

const Container = styled.div`
	width: 100%;
	position: relative;
`;

const Counter = styled.div`
	position: absolute;
	z-index: 1;
	left: -10px;
	top: 50%;
	transform: translate(0%, -50%);
	line-height: 130%;
	border: 2px solid #ffffff;
	border-radius: 50%;
	background: ${({theme}) => theme.background.tertiary};
	color: white;
	padding: 0.45em;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-family: "Khand", sans-serif;
	font-weight: 600;
	font-size: 12px;

	div {
		height: 0;
		margin-top: -1.2em;
	}

	&:after {
		content: "";
		display: block;
		height: 0;
		width: 100%;
		padding-bottom: 100%;
	}
`;

const LinearProgressStyled = styled(LinearProgress)`
	&.MuiLinearProgress-root {
		width: 100%;
		height: 8px;
		border-radius: 0;
	}

	&.${linearProgressClasses.colorPrimary} {
		background: #cccccc;
	}

	.${linearProgressClasses.bar} {
		border-radius: 0;
		background: ${({theme}) => theme.background.secondary};
	}
`;

interface IBadgesProgress {
	count: number;
	total: number;
}

export const BadgesProgress: FC<IBadgesProgress> = ({count, total}) => {
	const progress = (count / total) * 100;

	return (
		<Wrapper>
			<div>
				{count}/{total}
			</div>

			<Container>
				<Counter>
					<div>{count}</div>
				</Counter>
				<LinearProgressStyled variant="determinate" value={progress} />
			</Container>
		</Wrapper>
	);
};
